<div class="hero" [class]="image">
    <h1 class=hero-title>Wimbledon's finest taste of Thailand</h1>
</div>
<router-outlet></router-outlet>